export default "__VITE_ASSET__BbZlKgSZ__"